import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'
import moment from 'moment'

Vue.use(Vuex)

const state = {
  inOrders: [],
  allDetails: [],
  inOrder: {
    details: [],
    shipments: [],
    revisions: [],
    revisions_quote: [],
    payments: [],
    invoices: [],
    attachments: [],
    delivery_dates: []
  },
  categories: [],
  inOrderDetailsWithFabricated: [],
  inOrderDetailsWithShipment: [],
  submittals: [],
  changeOrders: [],
  payments: [],
  invoices: [],
  shipments: [],
  galleries: [],
  paginationGallery: {
    currentPage: 1,
    perPage: 5,
    totalInOrders: 0,
    totalPages: 0
  },
  paginationShipments: {
    currentPage: 1,
    perPage: 5,
    totalInOrders: 0,
    totalPages: 0
  },
  deliveryDeadlines: [],
  fieldUsedDrawings: [],
  shipment: {
    details: [],
    remisions: []
  },
  claims: [],
  claimsSeed: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalInOrders: 0,
    totalPages: 0
  },
  inOrdersCatalog: {
    shipments: [],
    categories: [],
    similarCategories: []
  },
  isModalFinishedProjectVisible: false,
  isModalVisible: false,
  filterParams: '',
  fabricatedsHistory: [],
  shippedHistory: [],
  isModalRevisionVisible: false,
  isModalSubmittalVisible: false,
  isModalShipmentClaimVisible: false,
  isModalShipmentDetailVisible: false,
  isModalShowClaimVisible: false,
  isModalViewsClaimVisible: false,
  isModalShipmentDetailEditVisible: false,
  isModalPaymentVisible: false,
  isModalScopeFabricatedHistoryVisible: false,
  isModalGalleryVisible: false,
  isModalDeliveryVisible: false,
  isModalRemisionVisible: false,
  isModalInvoiceVisible: false,
  isModalViewInvoiceVisible: false,
  isModalReceivedDateVisible: false,
  isModalChangeOrdersVisible: false,
  isModalScopeVisible: false,
  isModalChangeOrdersApproveVisible: false,
  isModalCategoryVisible: false,
  isModalFieldUsedDrawingsVisible: false,
  isModalImportScopeVisible: false,
  isModalImageVisible: false,
  isModalUpdatePurchaseOrderVisible: false,
  imageIdProject: false,
  imageIdCategory: false
}

const mutations = {
  INIT_SHIPMENT_DETAIL (state, payload) {
    state.shipment = payload
  },
  SET_IN_ORDERS (state, payload) {
    state.inOrders = payload.data

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalInOrders: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_IN_SCOPE (state, payload) {
    state.categories = payload.data
  },
  SET_CHANGE_ORDERS (state, payload) {
    state.changeOrders = payload.data
  },
  SET_INVOICES (state, payload) {
    state.invoices = payload.data
  },
  SET_SHIPMENTS (state, payload) {
    state.shipments = payload.data

    state.paginationShipments = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_GALLERIES (state, payload) {
    state.galleries = payload.data

    state.paginationGallery = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      total: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_DELIVERY_DEADLINES (state, payload) {
    state.deliveryDeadlines = payload.data
  },
  SET_FIELD_USED_DRAWINGS (state, payload) {
    state.fieldUsedDrawings = payload.data
  },
  SET_REVISIONS (state, payload) {
    state.inOrder.revisions = payload.data
  },
  SET_SUBMITTALS (state, payload) {
    state.submittals = payload.data
  },
  UPDATE_IN_ORDER (state, payload) {
    state.inOrder = payload
  },
  DELETE_IN_ORDER (state, payload) {
    const idx = state.inOrders.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.inOrders, idx)
    }
  },
  DELETE_SHIPMENT (state, payload) {
    const idx = state.shipments.findIndex(u => u.id === payload)
    if (idx >= 0) {
      Vue.delete(state.shipments, idx)
    }
  },
  UPDATE_IN_ORDER_ACTION (state, payload) {
    const idx = state.inOrders.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.inOrders, idx, payload)
    }
  },
  UPDATE_IN_ORDER_ACTION_STAGE_CHANGE (state, payload) {
    const idx = state.inOrders.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.inOrders, idx, payload)
    }

    setTimeout(() => { Vue.delete(state.inOrders, idx) }, 3000)
  },
  UPDATE_IN_ORDER_DETAIL (state, payload) {
    const idx = state.inOrder.details.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.inOrder.details, idx, payload)
    }
  },
  UPDATE_IN_ORDER_AMOUNTC (state, payload) {
    const idx = state.inOrder.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.inOrder, idx, payload)
    }
  },
  SET_SHIPMENT (state, payload) {
    state.shipment = payload.data
  },
  ADD_SHIPMENT (state, payload) {
    state.shipments.unshift(payload)
  },
  UPDATE_SHIPMENT (state, payload) {
    state.shipment = payload
  },
  UPDATE_SHIPMENT_RECORD (state, payload) {
    let idx = state.shipments.findIndex(e => e.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.shipments, idx, payload)
    }
  },
  ADD_PAYMENT (state, payload) {
    let idx = state.invoices.findIndex(e => e.id === payload.data.id)
    if (idx >= 0) {
      Vue.set(state.invoices, idx, payload.data)
    }
  },
  UPDATE_PAYMENT (state, payload) {
    let idx = state.payments.findIndex(e => e.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.payments, idx, payload)
    }
  },
  ADD_INVOICE (state, payload) {
    state.invoices.unshift(payload.data)
  },
  EDIT_INVOICE (state, payload) {
    let idx = state.invoices.findIndex(e => e.id === payload.data.id)
    if (idx >= 0) {
      Vue.set(state.invoices, idx, payload.data)
    }
  },
  DELETE_INVOICE (state, payload) {
    const idx = state.invoices.findIndex(e => e.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.invoices, idx)
    }
  },
  SET_SHIPMENT_CLAIMS (state, payload) {
    state.claims = payload.data
  },
  SET_CLAIM_SEEN_BY (state, payload) {
    state.claimsSeed = payload
  },
  UPDATE_SHIPMENT_CLAIM (state, payload) {
    const idx = state.claims.findIndex(e => e.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.claims, idx, payload)
    }
  },
  DELETE_SHIPMENT_DETAIL (state, idx) {
    if (idx >= 0) {
      Vue.delete(state.shipment.details, idx)
    }
  },
  UPDATE_ALL_DETAILS (state, payload) {
    state.allDetails = payload
  },
  UPDATE_SHIPMENTS_DETAILS (state, payload) {
    state.inOrderDetailsWithShipment = payload
  },
  CLEAN_SHIPMENTS_DETAILS (state) {
    state.inOrderDetailsWithShipment = []
  },
  SET_IN_ORDER (state, payload) {
    state.inOrder = payload.data
    if (!state.inOrder.payments) state.inOrder.payments = []
  },
  ADD_REVISION (state, payload) {
    state.inOrder.revisions.unshift(payload)
  },
  ADD_REVISION_QUOTE (state, payload) {
    state.inOrder.revisions_quote.unshift(payload)
  },
  UPDATE_REVISION (state, payload) {
    const idx = state.inOrder.revisions.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.inOrder.revisions, idx, payload)
    }
  },
  UPDATE_REVISION_QUOTE (state, payload) {
    const idx = state.inOrder.revisions_quote.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.inOrder.revisions_quote, idx, payload)
    }
  },
  DELETE_REVISION (state, payload) {
    const idx = state.inOrder.revisions.findIndex(u => u.id === payload.id)
    const idy = state.inOrder.revisions_quote.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.inOrder.revisions, idx)
    } else if (idy >= 0) {
      Vue.delete(state.inOrder.revisions_quote, idy)
    }
  },
  ADD_SUBMITTAL (state, payload) {
    state.submittals.unshift(payload)
  },
  UPDATE_SUBMITTAL (state, payload) {
    const idx = state.submittals.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.submittals, idx, payload)
    }
  },
  DELETE_SUBMITTAL (state, payload) {
    const idx = state.submittals.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.submittals, idx)
    }
  },
  SET_REMISION (state, payload) {
    state.shipment.remisions.unshift(payload)
  },
  UPDATE_REMISION (state, payload) {
    const idx = state.shipment.remisions.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.shipment.remisions, idx, payload)
    }
  },
  DELETE_REMISION (state, payload) {
    const idx = state.shipment.remisions.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.shipment.remisions, idx)
    }
  },
  ADD_ATTACHMENT (state, payload) {
    state.inOrder.attachments.unshift(payload)
  },
  DELETE_ATTACHMENT (state, payload) {
    const idx = state.inOrder.attachments.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.inOrder.attachments, idx)
    }
  },
  ADD_CHANGE_ORDER (state, payload) {
    state.changeOrders.unshift(payload)
  },
  UPDATE_CHANGE_ORDER_ACTION (state, payload) {
    const idx = state.changeOrders.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.changeOrders, idx, payload)
    }
  },
  DELETE_CHANGE_ORDER (state, payload) {
    const idx = state.changeOrders.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.changeOrders, idx)
    }
  },
  ADD_CATEGORY (state, payload) {
    state.inOrdersCatalog.categories.unshift(payload)
  },
  ADD_FIELD_USED_DRAWINGS (state, payload) {
    state.fieldUsedDrawings.unshift(payload)
  },
  UPDATE_FIELD_USED_DRAWINGS (state, payload) {
    const idx = state.fieldUsedDrawings.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.fieldUsedDrawings, idx, payload)
    }
  },
  DELETE_FIELD_USED_DRAWINGS (state, payload) {
    const idx = state.fieldUsedDrawings.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.delete(state.fieldUsedDrawings, idx)
    }
  },
  SET_MODAL_SCOPE_VISIBLE (state, payload) {
    state.isModalScopeVisible = payload
  },
  SET_MODAL_FINISHED_PROJECT_VISIBLE (state, payload) {
    state.isModalFinishedProjectVisible = payload
  },
  SET_MODAL_EDIT_AMOUNTC_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_IN_ORDERS_DETAILS_WITH_FABRICATED (state, payload) {
    state.inOrderDetailsWithFabricated = payload
  },
  SET_IN_ORDERS_DETAILS_WITH_SHIPMENT (state, payload) {
    const newPayload = payload.map(item => ({
      ...item,
      edit: false,
      old_quantity: item.quantity
    }))
    state.inOrderDetailsWithShipment = newPayload
  },
  SET_MODAL_SHIPMENT_VISIBLE (state, payload) {
    state.isModalShipmentClaimVisible = payload
  },
  SET_MODAL_SHIPMENT_DETAIL_VISIBLE (state, payload) {
    state.isModalShipmentDetailVisible = payload
  },
  SET_MODAL_SCOPE_FABRICATED_HISTORY_VISIBLE (state, payload) {
    state.isModalScopeFabricatedHistoryVisible = payload
  },
  SET_MODAL_REVISION_VISIBLE (state, payload) {
    state.isModalRevisionVisible = payload
  },
  SET_MODAL_SUBMITTAL_VISIBLE (state, payload) {
    state.isModalSubmittalVisible = payload
  },
  SET_MODAL_PAYMENT_VISIBLE (state, payload) {
    state.isModalPaymentVisible = payload
  },
  SET_MODAL_GALLERY_VISIBLE (state, payload) {
    state.isModalGalleryVisible = payload
  },
  SET_MODAL_DELIVERY_VISIBLE (state, payload) {
    state.isModalDeliveryVisible = payload
  },
  SET_MODAL_SHIPMENT_CLAIM_VISIBLE (state, payload) {
    state.isModalShipmentClaimVisible = payload
  },
  SET_MODAL_SHOW_CLAIM_VISIBLE (state, payload) {
    state.isModalShowClaimVisible = payload
  },
  SET_MODAL_VIEWS_CLAIM_VISIBLE (state, payload) {
    state.isModalViewsClaimVisible = payload
  },
  SET_MODAL_REMISION_VISIBLE (state, payload) {
    state.isModalRemisionVisible = payload
  },
  SET_MODAL_INVOICE_VISIBLE (state, payload) {
    state.isModalInvoiceVisible = payload
  },
  SET_MODAL_VIEW_INVOICE_VISIBLE (state, payload) {
    state.isModalViewInvoiceVisible = payload
  },
  SET_MODAL_SHIPMENT_DETAIL_EDIT_VISIBLE (state, payload) {
    state.isModalShipmentDetailEditVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.inOrdersCatalog[object] = payload.data
  },
  SET_FABRICATEDS_HISTORY (state, payload) {
    state.fabricatedsHistory = payload.data
  },
  SET_SHIPPED_HISTORY (state, payload) {
    state.shippedHistory = payload.data
  },
  SET_RECEIVED_MODAL_VISIBLE (state, payload) {
    state.isModalReceivedDateVisible = payload
  },
  SET_MODAL_CHANGE_ORDER (state, payload) {
    state.isModalChangeOrdersVisible = payload
  },
  SET_MODAL_CHANGE_ORDER_APPROVE (state, payload) {
    state.isModalChangeOrdersApproveVisible = payload
  },
  SET_MODAL_CATEGORY_VISIBLE (state, payload) {
    state.isModalCategoryVisible = payload
  },
  SET_MODAL_FIELD_USED_DRAWINGS (state, payload) {
    state.isModalFieldUsedDrawingsVisible = payload
  },
  SET_MODAL_IMPORT_SCOPE_VISIBLE (state, payload) {
    state.isModalImportScopeVisible = payload
  },
  SET_MODAL_IMAGE_VISIBLE (state, payload) {
    state.isModalImageVisible = payload['isImage']
    state.imageIdProject = payload['imageIdProject']
    state.imageIdCategory = payload['imageIdCategory']
  },
  SET_MODAL_UPDATE_PURCHASE_ORDER_VISIBLE (state, payload) {
    state.isModalUpdatePurchaseOrderVisible = payload
  }
}

const actions = {
  initShipment ({ commit }, payload) {
    commit('INIT_SHIPMENT_DETAIL', payload)
  },
  async loadInOrders ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`in-orders?&page=${payload.page}${state.filterParams}&stage=3`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_ORDERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCategoriesForScope ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`categories-details/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_SCOPE', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadInOrderDetailsWithFabricated ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`in-orders/${payload.id}/fabricated`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_ORDERS_DETAILS_WITH_FABRICATED', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadInOrderDetailsWithShipment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`in-orders/${payload.id}/shipment/${payload.idshipment}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_ORDERS_DETAILS_WITH_SHIPMENT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadChangeOrders ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`change-orders?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CHANGE_ORDERS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addCategory ({ commit }, payload) {
    const category = {
      type: payload.type
    }
    app.$Progress.start()
    try {
      const res = await axios.post(`/categories`, category)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if ('errors' in res.data) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.info', text: res.data.errors }, { root: true })
        } else {
          commit('ADD_CATEGORY', res.data)
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.info', text: 'strings.repeated_value' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addChangeOrder ({ commit }, payload) {
    let formData = new FormData()
    formData.append('name', payload.form.name)
    formData.append('type', payload.form.type)
    formData.append('amount', payload.form.amount)
    formData.append('date', moment(payload.form.date).format('YYYY-MM-DD'))
    formData.append('importFile', payload.file)
    formData.append('project_id', payload.project.id)
    formData.append('customer_id', payload.project.customer_id)

    app.$Progress.start()

    try {
      const response = await axios.post(`change-orders`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CHANGE_ORDER', response.data)
        commit('SET_MODAL_CHANGE_ORDER', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async approveChangeOrder ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    app.$Progress.start()

    try {
      const response = await axios.post(`change-orders/${payload.form.id}/approve`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CHANGE_ORDER_ACTION', response.data)
        commit('SET_MODAL_CHANGE_ORDER_APPROVE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionChangeOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`change-orders/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_CHANGE_ORDER_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: `projects.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteChangeOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`change-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_CHANGE_ORDER', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadSubmittals ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`submittals?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUBMITTALS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadInvoices ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`invoices?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_INVOICES', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadShipments ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`shipments?page=${payload.page}&project_id=${payload.project_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPMENTS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadGalleries ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`gallerys?page=${payload.page}&project_id=${payload.project_id}&mime_type[]=image/jpeg&mime_type[]=image/png`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_GALLERIES', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadDeliveryDeadLines ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`delivery-dates?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_DELIVERY_DEADLINES', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadFieldUsedDrawings ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`field-used-drawings?project_id=${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_FIELD_USED_DRAWINGS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addFieldUsedDrawing ({ commit }, payload) {
    let formData = new FormData()
    formData.append('category', payload.form.category)
    formData.append('drawing_number', payload.form.drawing_number)
    formData.append('title', payload.form.title)
    formData.append('revision', payload.form.revision)
    formData.append('date', moment(payload.form.date).format('YYYY-MM-DD'))
    formData.append('importFile', payload.file)
    formData.append('project_id', payload.project.id)
    formData.append('customer_id', payload.project.customer_id)

    app.$Progress.start()

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`field-used-drawings`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_FIELD_USED_DRAWINGS', response.data)
        commit('SET_MODAL_FIELD_USED_DRAWINGS', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  async editFieldUsedDrawing ({ commit }, payload) {
    let drawing = new FormData()
    drawing.append('category', payload.form.category)
    drawing.append('drawing_number', payload.form.drawing_number)
    drawing.append('title', payload.form.title)
    drawing.append('revision', payload.form.revision)
    drawing.append('date', moment(payload.form.date).format('YYYY-MM-DD'))
    drawing.append('importFile', payload.file)
    drawing.append('project_id', payload.form.project_id)
    drawing.append('customer_id', payload.form.customer_id)

    app.$Progress.start()

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`field-used-drawings/${payload.form.id}/update-file`, drawing, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', true, { root: true })
        commit('UPDATE_FIELD_USED_DRAWINGS', response.data)
        commit('SET_MODAL_FIELD_USED_DRAWINGS', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionFieldUsedDrawings ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`field-used-drawings/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_FIELD_USED_DRAWINGS_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: `projects.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteFieldUsedDrawing ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`field-used-drawings/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_FIELD_USED_DRAWINGS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async AddDelivery ({ commit }, payload) {
    const inOrder = {
      delivery_deadline: moment(payload.delivery_deadline).format('YYYY-MM-DD'),
      delivery_deadline_comments: payload.delivery_deadline_comments
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`in-orders/${payload.id}/delivery`, inOrder)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_IN_ORDER_ACTION', response.data)
        commit('SET_MODAL_DELIVERY_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addProjectDetail ({ commit }, payload) {
    const ProjectDetail = {
      category_id: parseInt(payload.detail.category.id),
      sequence: payload.detail.sequence,
      quantity: payload.detail.quantity,
      description: payload.detail.description,
      mark: payload.detail.mark,
      project_id: payload.project_id
    }
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('project-details', ProjectDetail)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_SCOPE', response)
        commit('SET_MODAL_SCOPE_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editProjectDetail ({ commit }, payload) {
    const ProjectDetail = {
      id: payload.detail.id,
      category_id: parseInt(payload.detail.category.id),
      sequence: payload.detail.sequence,
      quantity: payload.detail.quantity,
      description: payload.detail.description,
      mark: payload.detail.mark,
      project_id: payload.project_id
    }
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.put(`project-details/${payload.detail.id}`, ProjectDetail)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_SCOPE', response)
        commit('SET_MODAL_SCOPE_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteProjectDetail ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`project-details/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async updateScope ({ commit }, payload) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`in-orders/${payload.id}/scopes`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in-orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_IN_SCOPE', response)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async importScopeData ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await Vue.axios.post(`project-details/${payload.project_id}/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_SCOPE', response)
        commit('SET_MODAL_IMPORT_SCOPE_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.scopes', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async loadShipment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`shipments/${payload.idshipment}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.shipment', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPMENT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addShipment ({ commit }, payload) {
    const shipment = {
      remission_number: payload.shipment.remission_number,
      addressee: payload.shipment.addressee,
      shipped_date: moment(payload.shipment.shipped_date).format('YYYY-MM-DD'),
      estimate_arrival: moment(payload.shipment.estimate_arrival).format('YYYY-MM-DD'),
      comments: payload.shipment.comments,
      details: payload.form,
      remisions: payload.remisions,
      project_id: payload.idProject
    }
    app.$Progress.start()
    try {
      const response = await axios.post(`shipments`, shipment)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.shipments', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_SHIPMENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shipments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editShipment ({ commit }, payload) {
    const shipment = {
      remission_number: payload.remission_number,
      addressee: payload.addressee,
      shipped_date: moment(payload.shipped_date).format('YYYY-MM-DD'),
      estimate_arrival: moment(payload.estimate_arrival).format('YYYY-MM-DD'),
      comments: payload.comments,
      details: payload.details,
      project_id: payload.idProject
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`shipments/${payload.id}`, shipment)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.shipments', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SHIPMENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.shipments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addShipmentDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`in-orders/${payload.id}/shipments/addShipmentDetail/${payload.shipment_id}`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in-orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SHIPMENTS_DETAILS', response.data)
        commit('SET_MODAL_SHIPMENT_DETAIL_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },

  async updateShipmentDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`in-orders/${payload.id}/shipments/details/${payload.shipment_id}`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in-orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SHIPMENTS_DETAILS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteShipmentDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('DELETE_SHIPMENT_DETAIL', payload.index)
    app.$Progress.finish()
  },
  async deleteInOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`in-orders/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in-order', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_IN_ORDER', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.in-order', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadInOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/${payload}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_IN_ORDER', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addRemisionShipment ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('thumbnail', payload.thumbnail)
    formData.append('mime_type', payload.mime_type)
    formData.append('description', payload.remision.description)
    formData.append('date', moment(payload.remision.date).format('YYYY-MM-DD'))
    formData.append('project_id', payload.project_id)
    formData.append('remision', 1)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`shipments/remision`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', true, { root: true })
        commit('SET_REMISION', response.data)
        commit('SET_MODAL_REMISION_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.remision', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editRemisionShipment ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('thumbnail', payload.thumbnail)
    formData.append('mime_type', payload.mime_type)
    formData.append('description', payload.remision.description)
    formData.append('date', moment(payload.remision.date).format('YYYY-MM-DD'))
    formData.append('project_id', payload.project_id)
    formData.append('remision', 1)
    formData.append('_method', 'put')
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`shipments/remision/${payload.remision.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', true, { root: true })
        commit('UPDATE_REMISION', response.data)
        commit('SET_MODAL_REMISION_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.remision', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async addRevision ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('package_name', payload.revision.package_name)
    formData.append('starting_date', moment(payload.revision.starting_date).format('YYYY-MM-DD'))
    formData.append('project_id', payload.project.id)
    formData.append('customer_id', payload.project.customer_id)
    formData.append('type', payload.revision.type)
    formData.append('comments', payload.revision.comments)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`revisions`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.revisions', text: checkErrors.message }, { root: true })
      } else {
        if (payload.revision.type === 1 || payload.revision.type === 4) {
          commit('ADD_REVISION_QUOTE', response.data)
        } else {
          commit('ADD_REVISION', response.data)
        }
        commit('SET_MODAL_REVISION_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.revisions', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editRevision ({ commit }, payload) {
    const revision = {
      status: 1,
      approved: 0,
      starting_date: moment(payload.revision.starting_date).format('YYYY-MM-DD'),
      end_date: payload.revision.end_date ? moment(payload.revision.end_date).format('YYYY-MM-DD') : null,
      created_by: payload.revision.created_by,
      project_id: payload.project.id,
      customer_id: payload.project.customer_id
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`revisions/${payload.revision.id}`, revision)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.revisions', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_REVISION', response.data)
        commit('SET_MODAL_REVISION_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.revisions', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteRevision ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`revisions/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_REVISION', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addSubmittal ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('package_name', payload.submittal.package_name)
    formData.append('starting_date', moment(payload.submittal.starting_date).format('YYYY-MM-DD'))
    formData.append('project_id', payload.project.id)
    formData.append('customer_id', payload.project.customer_id)
    formData.append('type', payload.submittal.type)
    formData.append('comments', payload.submittal.comments)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`submittals`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.submittals', text: checkErrors.message }, { root: true })
      } else {
        if (payload.submittal.type === 1 || payload.submittal.type === 4) {
          commit('ADD_SUBMITTAL_QUOTE', response.data)
        } else {
          commit('ADD_SUBMITTAL', response.data)
        }
        commit('SET_MODAL_SUBMITTAL_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.submittals', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editSubmittal ({ commit }, payload) {
    const submittal = {
      status: 1,
      approved: 0,
      starting_date: moment(payload.submittal.starting_date).format('YYYY-MM-DD'),
      end_date: payload.submittal.end_date ? moment(payload.submittal.end_date).format('YYYY-MM-DD') : null,
      created_by: payload.submittal.created_by,
      project_id: payload.project.id,
      customer_id: payload.project.customer_id
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`submittals/${payload.submittal.id}`, submittal)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.submittals', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SUBMITTAL', response.data)
        commit('SET_MODAL_SUBMITTAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.submittals', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionSubmittal ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`submittals/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SUBMITTAL', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: `projects.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteSubmittal ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`submittals/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SUBMITTAL', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async fabricatedDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`in-orders/${payload.project_id}/scopes/${payload.id}/fabricateds`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_FABRICATEDS_HISTORY', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async getShippedDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`in-orders/${payload.project_id}/scopes/${payload.id}/shipped`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPPED_HISTORY', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },  
  async importData ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('thumbnail', payload.thumbnail)
    formData.append('mime_type', payload.mime_type)
    formData.append('description', payload.gallery.description)
    formData.append('date', moment(payload.gallery.date).format('YYYY-MM-DD'))
    formData.append('project_id', payload.project_id)
    formData.append('shipment_id', payload.gallery.shipment_id)

    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`gallerys`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_ATTACHMENT', response.data)
        commit('SET_MODAL_GALLERY_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteRemision ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`attachments/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_REMISION', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteGallery ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`gallerys/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_ATTACHMENT', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async approvedRevision ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`revisions/${payload.id}/approved`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_REVISION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.in_orders', text: `projects.approved`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async approvedRevisionQuote ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`revisions/${payload.id}/approved`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_REVISION_QUOTE', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.in_orders', text: `projects.approved`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async approvedPayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`payments/${payload.id}/approved`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.payments', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_PAYMENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: `projects.approved`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionInOrder ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`in-orders/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_IN_ORDER', response.data)
        commit('UPDATE_IN_ORDER_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.in_orders', text: `strings.${payload.action}`, icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addPayment ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('date_pay', payload.payment.date_pay)
    formData.append('amount', payload.payment.amount)
    formData.append('project_id', payload.project.id || payload.payment.id)
    formData.append('invoice_id', payload.payment.invoice_id)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('payments', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.payments', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PAYMENT', response.data)
        commit('SET_MODAL_PAYMENT_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editPayment ({ commit }, payload) {
    const payment = {
      date_pay: payload.payment.date_pay,
      amount: payload.payment.amount
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`payments/${payload.payment.id}`, payment)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.payments', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PAYMENT', response.data)
        commit('SET_MODAL_PAYMENT_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.payments', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deletePayment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`payments/${payload}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_PAYMENT', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addInvoice ({ commit }, payload) {
    let formData = new FormData()
    formData.append('importFile', payload.file)
    formData.append('folio', payload.invoice.folio)
    formData.append('amount', payload.invoice.amount)
    formData.append('invoice_date', payload.invoice.invoice_date)
    formData.append('type', parseInt(payload.invoice.type))
    formData.append('project_id', payload.project.id || payload.invoice.id)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post('invoices', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_INVOICE', response.data)
        commit('SET_MODAL_INVOICE_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.invoices', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editInvoice ({ commit }, payload) {
    const invoice = {
      folio: payload.invoice.folio,
      invoice_date: payload.invoice.invoice_date,
      amount: payload.invoice.amount,
      type: payload.type
    }

    app.$Progress.start()

    try {
      const response = await axios.put(`invoices/${payload.invoice.id}`, invoice)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.invoices', text: checkErrors.message }, { root: true })
      } else {
        commit('EDIT_INVOICE', response.data)
        commit('SET_MODAL_INVOICE_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.invoices', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteInvoice ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`invoices/${payload.id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in-order', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_INVOICE', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.in-order', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editInOrderDetail ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`in-orders/${payload.id_proyect}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_IN_ORDER_ACTION', response)
        commit('SET_MODAL_EDIT_AMOUNTC_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/in-orders/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportDates ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/in-orders-dates/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  printReportRecord ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/in-orders/${payload.id}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}?${payload.filter}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.in_orders', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.object ? payload.object : payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionProjectFinished ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.post(`/in-orders/${payload.id}/finished`, payload)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_MODAL_FINISHED_PROJECT_VISIBLE', false)
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_IN_ORDER_ACTION_STAGE_CHANGE', res.data)
        commit('SET_MODAL_FINISHED_PROJECT_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addShipmentClaim ({ commit }, payload) {
    const claim = {
      date: payload.date,
      question: payload.question,
      answer: payload.answer,
      shipment_id: parseInt(payload.id),
      project_id: parseInt(payload.project_id),
      customer_id: parseInt(payload.customer_id)

    }
    app.$Progress.start()
    try {
      const res = await axios.post(`/claims`, claim)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_SHIPMENT_CLAIM_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async editShipmentClaim ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.put(`/claims/${payload.id}`, payload)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_SHIPMENT_CLAIM_VISIBLE', false)
        commit('UPDATE_SHIPMENT_CLAIM', res.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadClaims ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.get(`/claims?${payload.filterBy}`)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SHIPMENT_CLAIMS', res.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async setClamSeenBy ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.post(`/set-claims-seen`, payload)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CLAIM_SEEN_BY', res.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadClamSeenBy ({ commit }, payload) {
    app.$Progress.start()
    try {
      const res = await axios.post(`/get-claims-seen`, payload)
      const checkErrors = checkResponse(res)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CLAIM_SEEN_BY', res.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteCategory ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.put(`categories/${payload.id}/inactive`, { type: payload.type })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.warning', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.categories', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async assignedPurchaseOrder ({ commit }, payload) {
    let formData = new FormData()
    formData.append('file', payload.file)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`in-orders/${payload.project_id}/purchase-order`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.quotes', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_MODAL_UPDATE_PURCHASE_ORDER_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('UPDATE_IN_ORDER_ACTION', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.quotes', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async loadCatalogCustomer ({ dispatch }, payload) {
    dispatch('ToQuotes/loadCatalog', payload, { root: true })
  },
  setModalImageVisible ({ commit }, payload) {
    commit('SET_MODAL_IMAGE_VISIBLE', payload)
  },
  setModalUpdatePurchaseOrderVisible ({ commit }, payload) {
    commit('SET_MODAL_UPDATE_PURCHASE_ORDER_VISIBLE', payload)
  },
  setModalImportScopeVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_SCOPE_VISIBLE', payload)
  },
  setModalCategoriesVisible ({ commit }, payload) {
    commit('SET_MODAL_CATEGORIES_VISIBLE', payload)
  },
  setModalFinishedProjectVisible ({ commit }, payload) {
    commit('SET_MODAL_FINISHED_PROJECT_VISIBLE', payload)
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_EDIT_AMOUNTC_VISIBLE', payload)
  },
  loadCatalogAux ({ commit }, payload) {
    commit('SET_CATALOG', { object: payload.url, payload: payload })
  },
  setModalRevisionVisible ({ commit }, payload) {
    commit('SET_MODAL_REVISION_VISIBLE', payload)
  },
  setModalSubmittalVisible ({ commit }, payload) {
    commit('SET_MODAL_SUBMITTAL_VISIBLE', payload)
  },
  cleanShipmentsDetails ({ commit }, payload) {
    commit('CLEAN_SHIPMENTS_DETAILS')
  },
  setModalPaymentVisible ({ commit }, payload) {
    commit('SET_MODAL_PAYMENT_VISIBLE', payload)
  },
  setModalShipmentClaimVisible ({ commit }, payload) {
    commit('SET_MODAL_SHIPMENT_CLAIM_VISIBLE', payload)
  },
  loadAllDetailsUsed ({ commit }, payload) {
    let allDetail = []
    state.categories.forEach(category => {
      category.details.forEach(detail => {
        let detailNew = true
        payload.forEach(usedDetail => {
          if (usedDetail.scope === detail.scope) {
            detailNew = false
          }
        })
        if (detailNew) {
          let [send, miss] = detail.shipment_complete_total.split('/')
          detail.send = send
          detail.missing = miss
          detail.quantity = 0
          detail.new = 0
          allDetail.push(detail)
        }
      })
    })
    commit('UPDATE_ALL_DETAILS', allDetail)
  },
  setModalShipmentDetailVisible ({ commit }, payload) {
    commit('SET_MODAL_SHIPMENT_DETAIL_VISIBLE', payload)
  },
  setModalShowClaimVisible ({ commit }, payload) {
    commit('SET_MODAL_SHOW_CLAIM_VISIBLE', payload)
  },
  setModalViewsClaimVisible ({ commit }, payload) {
    commit('SET_MODAL_VIEWS_CLAIM_VISIBLE', payload)
  },
  setModalScopeFabricatedHistoryVisible ({ commit }, payload) {
    commit('SET_MODAL_SCOPE_FABRICATED_HISTORY_VISIBLE', payload)
  },
  setModalGalleryVisible ({ commit }, payload) {
    commit('SET_MODAL_GALLERY_VISIBLE', payload)
  },
  setModalDeliveryVisible ({ commit }, payload) {
    commit('SET_MODAL_DELIVERY_VISIBLE', payload)
  },
  setModalRemisionVisible ({ commit }, payload) {
    commit('SET_MODAL_REMISION_VISIBLE', payload)
  },
  setModalInvoiceVisible ({ commit }, payload) {
    commit('SET_MODAL_INVOICE_VISIBLE', payload)
  },
  setModalViewInvoiceVisible ({ commit }, payload) {
    commit('SET_MODAL_VIEW_INVOICE_VISIBLE', payload)
  },
  setModalReceivedDateVisible ({ commit }, payload) {
    commit('SET_RECEIVED_MODAL_VISIBLE', payload)
  },
  setModalShipmentDetailEditVisible ({ commit }, payload) {
    commit('SET_MODAL_SHIPMENT_DETAIL_EDIT_VISIBLE', payload)
  },
  setModalChangeOrdersVisible ({ commit }, payload) {
    commit('SET_MODAL_CHANGE_ORDER', payload)
  },
  setModalChangeOrdersApproveVisible ({ commit }, payload) {
    commit('SET_MODAL_CHANGE_ORDER_APPROVE', payload)
  },
  setModalFieldUsedDrawingsVisible ({ commit }, payload) {
    commit('SET_MODAL_FIELD_USED_DRAWINGS', payload)
  },
  setModalScopeVisible ({ commit }, payload) {
    commit('SET_MODAL_SCOPE_VISIBLE', payload)
  },
  setModalCategoryVisible ({ commit }, payload) {
    commit('SET_MODAL_CATEGORY_VISIBLE', payload)
  },
  async addReceivedDate ({ commit }, payload) {
    app.$Progress.start()
    let form = {
      received_date: payload.data
    }

    try {
      const response = await axios.put(`shipments/${payload.id}/recieved-date`, form)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_SHIPMENT_RECORD', response.data)
        commit('SET_RECEIVED_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.projects', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteShipment ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`shipments/${payload}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'projects.shipment', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SHIPMENT', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'projects.shipment', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  loadEmployees ({ commit, dispatch, getters }, payload) {
    dispatch('ToQuotes/loadEmployees', payload, { root: true })
  },
  setModalContactVisible ({ commit, dispatch, getters }, payload) {
    dispatch('ProjectContacts/setModalContactVisible', { payload }, { root: true })
  },
  async downloadTemplate ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${Vue.axios.defaults.baseURL}/project-details/template?format=csv`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  inOrder: state => state.inOrder,
  allDetails: state => state.allDetails,
  allDetailsUsed: state => state.allDetailsUsed,
  categories: state => state.categories,
  inOrderDetailsWithFabricated: state => state.inOrderDetailsWithFabricated,
  inOrderDetailsWithShipment: state => state.inOrderDetailsWithShipment,
  submittals: state => state.submittals,
  changeOrders: state => state.changeOrders,
  invoices: state => state.invoices,
  shipments: state => state.shipments,
  galleries: state => state.galleries,
  deliveryDeadlines: state => state.deliveryDeadlines,
  fieldUsedDrawings: state => state.fieldUsedDrawings,
  shipment: state => state.shipment,
  claims: state => state.claims,
  claimsSeed: state => state.claimsSeed,
  inOrders: state => state.inOrders,
  inOrdersCatalog: state => state.inOrdersCatalog,
  pagination: state => state.pagination,
  paginationGallery: state => state.paginationGallery,
  paginationShipments: state => state.paginationShipments,
  isModalRevisionVisible: state => state.isModalRevisionVisible,
  isModalSubmittalVisible: state => state.isModalSubmittalVisible,
  isModalPaymentVisible: state => state.isModalPaymentVisible,
  isModalShipmentClaimVisible: state => state.isModalShipmentClaimVisible,
  isModalShipmentDetailVisible: state => state.isModalShipmentDetailVisible,
  isModalViewsClaimVisible: state => state.isModalViewsClaimVisible,
  isModalShowClaimVisible: state => state.isModalShowClaimVisible,
  isModalScopeFabricatedHistoryVisible: state => state.isModalScopeFabricatedHistoryVisible,
  fabricatedsHistory: state => state.fabricatedsHistory,
  shippedHistory: state => state.shippedHistory,
  isModalGalleryVisible: state => state.isModalGalleryVisible,
  isModalDeliveryVisible: state => state.isModalDeliveryVisible,
  isModalRemisionVisible: state => state.isModalRemisionVisible,
  isModalInvoiceVisible: state => state.isModalInvoiceVisible,
  isModalViewInvoiceVisible: state => state.isModalViewInvoiceVisible,
  isModalShipmentDetailEditVisible: state => state.isModalShipmentDetailEditVisible,
  filterParams: state => state.filterParams,
  isModalFinishedProjectVisible: state => state.isModalFinishedProjectVisible,
  isModalVisible: state => state.isModalVisible,
  isModalScopeVisible: state => state.isModalScopeVisible,
  toQuotesCatalog: (state, getters, rootState, rootGetters) => rootGetters['ToQuotes/toQuotesCatalog'],
  isModalReceivedDateVisible: state => state.isModalReceivedDateVisible,
  isModalChangeOrdersVisible: state => state.isModalChangeOrdersVisible,
  isModalChangeOrdersApproveVisible: state => state.isModalChangeOrdersApproveVisible,
  isModalCategoryVisible: state => state.isModalCategoryVisible,
  isModalImportScopeVisible: state => state.isModalImportScopeVisible,
  isModalImageVisible: state => state.isModalImageVisible,
  isModalUpdatePurchaseOrderVisible: state => state.isModalUpdatePurchaseOrderVisible,
  isModalFieldUsedDrawingsVisible: state => state.isModalFieldUsedDrawingsVisible,
  isModalContactVisible: (state, getters, rootState, rootGetters) => rootGetters['ProjectContacts/isModalContactVisible'],
  employees: (state, getters, rootState, rootGetters) => rootGetters['ToQuotes/employees'],
  imageIdProject: state => state.imageIdProject,
  imageIdCategory: state => state.imageIdCategory
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
